import { Box, Typography } from "@mui/material";
import { usePlannerContext } from "../../services/context/planner-context";
import { TextFieldName } from "../ui/text-field-name";

export const CardName = ({ nodeId, nodeData, editMode, setEditMode }) => {
  const {  setNodes } = usePlannerContext();
  const handleUpdateName = (newName) => {
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              building: {
                ...node.data.building,
                name: newName,
              },
            },
          };
        }
        return node;
      })
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        width: "100%",
        mt: "2px",
      }}
    >
      {editMode ? (
        <>
          <TextFieldName
            label={"Name"}
            placeholder="Enter Name"
            value={nodeData.building?.name}
            name="name"
            setValue={handleUpdateName}
            small={true}
            type={
              nodeData.type === "carparking" || nodeData.type === "truckparking"
                ? "Area "
                : "Building "
            }
            area={nodeData}
            setEditMode={setEditMode}
            /* error={error}
                setError={setError}
                errorAPI={errorAPI}
                setErrorAPI={setErrorAPI} */
          />
        </>
      ) : (
        <Typography
          sx={{
            fontSize: "14px",
            color: "#fff",
            fontWeight: 500,
            lineHeight: 2.1,
          }}
        >
          {nodeData.building?.name || ""}
        </Typography>
      )}
    </Box>
  );
};
